// Footer newsletter — subscribes through the Kit (ConvertKit) form's public
// endpoint (form 9881882 / embed uid 23e526b22f, extracted from the Kit embed
// script). The endpoint is built for browser calls — no secret credentials.

const KIT_FORM_URL = 'https://app.kit.com/forms/9881882/subscriptions';

export function initNewsletter(): void {
  const form = document.querySelector<HTMLFormElement>('.footer__newsletter-form');
  if (!form) return;
  const input = form.querySelector<HTMLInputElement>('input[type="email"]');
  const button = form.querySelector<HTMLButtonElement>('button[type="submit"]');
  const status = form.querySelector<HTMLParagraphElement>('.footer__newsletter-status');
  if (!input || !button || !status) return;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const email = input.value.trim();
    if (!email) {
      input.focus();
      return;
    }

    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Subscribing…';
    status.hidden = true;

    try {
      const data = new FormData();
      data.set('email_address', email);
      const response = await fetch(KIT_FORM_URL, {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
      });
      const result = (await response.json()) as { status?: string };
      if (!response.ok || result.status === 'failed') throw new Error('subscribe failed');
      status.textContent = 'Thanks — check your inbox to confirm your subscription.';
      status.classList.remove('is-error');
      form.reset();
    } catch {
      status.textContent = 'Something went wrong. Please try again.';
      status.classList.add('is-error');
    } finally {
      status.hidden = false;
      button.disabled = false;
      button.textContent = label;
    }
  });
}
